<script lang="ts">
  /**
   * Monster - Player-controlled monster character
   * Collects letters to spell words in Monster Mode
   */

  import { scale } from 'svelte/transition';
  import { cubicOut } from 'svelte/easing';

  // Props
  interface Props {
    x: number;
    y: number;
    showEat?: boolean;
    isMoving?: boolean;
    debug?: boolean;
  }

  let { x = 0, y = 0, showEat = false, isMoving = false, debug = false }: Props = $props();
</script>

<div
  class="monster"
  class:eating={showEat}
  class:moving={isMoving}
  style="left: {x}px; top: {y}px;"
  transition:scale={{ duration: 300, easing: cubicOut }}
>
  <div class="monster-emoji">👾</div>

  <!-- Debug collision boundary -->
  {#if debug}
    <div class="debug-boundary" title="Monster collision radius: 50px"></div>
  {/if}
</div>

<style>
  .monster {
    position: absolute;
    width: 100px;
    height: 100px;
    transform: translate(-50%, -50%);
    z-index: 50;
    pointer-events: none;
    animation: breathe 3s ease-in-out infinite;
  }

  .monster-emoji {
    font-size: 100px;
    line-height: 1;
    transition: transform 0.1s ease;
  }

  /* Idle breathing animation */
  @keyframes breathe {
    0%, 100% {
      transform: translate(-50%, -50%) scale(1);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.05);
    }
  }

  /* Moving state - add bounce */
  .monster.moving {
    animation: breathe 0.3s ease-in-out infinite;
  }

  .monster.moving .monster-emoji {
    transform: rotate(-5deg);
  }

  /* Eating animation */
  .monster.eating {
    animation: chomp 0.3s ease-in-out;
  }

  @keyframes chomp {
    0%, 100% {
      transform: translate(-50%, -50%) scale(1);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.2) rotate(5deg);
    }
  }

  /* Debug collision boundary */
  .debug-boundary {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100px; /* Monster radius = 50px, so diameter = 100px */
    height: 100px;
    transform: translate(-50%, -50%);
    border: 2px solid lime;
    border-radius: 50%;
    background: rgba(0, 255, 0, 0.1);
    pointer-events: none;
    z-index: 100;
  }

  /* Responsive */
  @media (max-width: 767px) {
    .monster {
      width: 80px;
      height: 80px;
    }

    .monster-emoji {
      font-size: 80px;
    }
  }
</style>
